module.exports = __webpack_public_path__ + "static/media/23_A.ab47bf3b.png";